import { ClientStatusConfig, ClientStatusType } from "@/shared/types/clientStatus";

interface ClientStatusBadgeProps {
  status: ClientStatusType | null | undefined;
  className?: string;
}

export function ClientStatusBadge({ status, className = "" }: ClientStatusBadgeProps) {
  if (!status) return null;

  const config = ClientStatusConfig[status];
  if (!config) return null;

  return (
    <span
      className={`inline-flex items-center rounded-full border border-primary bg-white px-2.5 py-0.5 text-sm font-medium text-primary ${className}`}
    >
      {config.label}
    </span>
  );
}
